import { AxiosResponse, InternalAxiosRequestConfig } from "axios";
import { AppException } from "./exception";
import { JSEncrypt } from "encryptlong";
import { appConfig } from "@/appConfig";
import { MiaoMiaoEncrypt } from "./encrypt";
import { showFailToast } from "vant";
import { createSdkFactory } from "../sdk/ClientSdk";
import { platformAdpter } from "./adpter";
import { getQueryParam } from "./getUrlParam";


/**
 * 针对中台项目服务器返回做统一处理
 * 请不要直接改变文件，请通过重新实现不同函数在 appConfig 中进行配置
 * 完成修改后使用 ay-cli 将不同平台的配置文件更新到下一个资源包
 * @param config 
 */
export function transformResponseCenter(config: AxiosResponse) {
    if (config === undefined) {
        throw new AppException('已超时，请稍后再试');
    }
    if (config.status === 400) {
        if (config.data.message) {
            throw new AppException(config.data.message);
        }
        const errors = Object.values(config.data.errors) || [];
        throw new AppException(String(errors[0]) || '参数有误');
    }

    // 401返回重新登录
    if (config.status === 401) {
        throw new AppException(config.data?.msg || '登录失效');
    }
    if (config.status !== 200) {
        throw new AppException(config.data?.msg || '登录失效');
    }
    if ((config.data.code || config.data.status) !== 200) {
        if (config.data?.status === 401) {
            throw new AppException(config.data?.msg);
        }
        throw new AppException((config.data.message || config.data.msg));
    }
    return config.data;
}

/**
 * 中台请求处理
 * @param config 
 * @returns 
 */
export function transformRequestCenter(config: InternalAxiosRequestConfig) {
    config.headers['Content-Type'] = 'application/json';
    return config;
}


/**
 * 饭橘请求处理
 * @param config 
 * @returns 
 */
export function transformRequestFanju(config: InternalAxiosRequestConfig) {
    const encryptor = new JSEncrypt();
    const publicKey = `-----BEGIN PUBLIC KEY-----MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEAr4NW5zC4Cz+f28ZfrfCvn9fCBysUdmVAmcBlc8Ozfcu1+aoeOy7rDHF3gM6v4MEdtH9cK4Ku0rKWDzJGGB0MdrMtz2Lf8vi/BihqzBW1OXIiHCsZrQw9O194thS7YXYZmWNyZpxAqHWfbPbutHhhOmrYuDbVpSNbgb6dq/MZa/4RDny8ddXPs9szLFNw3OsrEcsmZa1T/6NJCY1blGY6ERR6Fojd1ffUBJ7XxHpv8DFJyvceiEQgH/aJW5v0O1fqxDo3Ok3btOLZPfkhT+BI+b4NuuztFMqqYuXKT3rkqdXY3t/ZqW7JGy1RcdD244SXxRNxof7KUYauD4LmAJReQQIDAQAB-----END PUBLIC KEY-----`;
    encryptor.setPublicKey(publicKey);
    const rsaData = encryptor.encryptLong(JSON.stringify(config.data));
    const nextData = rsaData ? { data: rsaData } : null;
    config.data = nextData;
    config.headers['Content-Type'] = 'application/json';
    return config;
}

/**
 * 阿柴请求逻辑处理
 * @param config 
 * @returns 
 */
export function transformRequestAchai(config: InternalAxiosRequestConfig) {
    config.headers['Content-Type'] = 'application/json';
    return config;
}

/**
 * 阿柴响应逻辑处理
 * @param config 
 */
export function transformResponseAchai(config: AxiosResponse) {
    if (config === undefined) {
        throw new AppException('已超时，请稍后再试');
    }
    if (config.status === 400) {
        if (config.data.message) {
            throw new AppException(config.data.message);
        }
        const errors = Object.values(config.data.errors) || [];
        throw new AppException(String(errors[0]) || '参数有误');
    }

    // 401返回重新登录
    if (config.status === 401) {
        throw new AppException(config.data?.msg || '登录失效');
    }
    if (config.status !== 200) {
        throw new AppException(config.data?.msg || '登录失效');
    }
    if ((config.data.code || config.data.status) !== 200) {
        if (config.data?.status === 401) {
            throw new AppException(config.data?.msg);
        }
        throw new AppException((config.data.message || config.data.msg));
    }
    return config.data;
}


/**
 * 阿柴请求逻辑处理
 * @param config 
 * @returns 
 */
export async function transformRequestMiaomiao(config: InternalAxiosRequestConfig) {
    config.headers['Content-Type'] = 'multipart/form-data';
    const user = await appConfig.sdk.loadUser();
    config.headers['cp'] = MiaoMiaoEncrypt(JSON.stringify({
        MemberId: user.id,
        Platform: user.platform,
        oaid: user.oaid,
        PlatformVersion: user.deviceVersion,
        AppVersion: user.app_version,
        DeviceModel: user.deviceModel,
        DeviceVendors: user.manufacturer,
        deviceInfo: getQueryParam('deviceInfo')
    }));
    if (config.method === 'post') {
        const data = config.data;
        config.data = {
            data: MiaoMiaoEncrypt(JSON.stringify(data)),
        };
    }
    return config;
}

/**
 * 阿柴响应逻辑处理
 * @param config 
 */
export function transformResponseMiaomiao(config: AxiosResponse) {
    if (config === undefined) {
        throw new AppException('已超时，请稍后再试');
    }
    if (parseInt((config.data || {}).code) === 10000) {
        showFailToast('今日挑战任务②已完成');
        const payload = {
            action: 'refreshPunchActivity',
        };
        // 兼容刷新
        platformAdpter({
            ios: function () {
                return createSdkFactory(
                    data => window.webkit.messageHandlers.evaluateJsToNative.postMessage(data),
                    payload,
                );
            },
            android: function() {
                return createSdkFactory(
                    data => window.callNative.evaluateJsToNative(data),
                    payload,
                );
            },
            harmony: function () {
                return createSdkFactory(
                    data => window.callNative.evaluateJsToNative(data),
                    payload,
                );
            }
        });
        return config.data;
    }

    if (config.status === 400) {
        if (config.data.message) {
            throw new AppException(config.data.message);
        }
        const errors = Object.values(config.data.errors) || [];
        throw new AppException(String(errors[0]) || '参数有误');
    }

    // 401返回重新登录
    if (config.status === 401) {
        throw new AppException(config.data?.message || config.data?.msg || '登录失效');
    }
    if (config.status !== 200) {
        throw new AppException(config.data?.message || config.data?.msg || '登录失效');
    }
    if ((config.data.code || config.data.status) !== 200) {
        if (config.data?.status === 401) {
            throw new AppException(config.data?.msg);
        }
        throw new AppException((config.data.message || config.data.msg));
    }
    return config.data;
}

